import React from "react";
import "./HowItWorks.css";
import estimateImg from "../../assets/estimate.png";
import analysisImg from "../../assets/analysis.png";
import saveImg from "../../assets/save.png";
import chooseImg from "../../assets/choose.png";
import finetuneImg from "../../assets/finetune.png";
import visualizeImg from "../../assets/visualize.png";

const features = [
  {
    image: chooseImg,
    title: "Choose from hundreds of Porsches",
    description: (
      <>Browse <span className="how-it-works__feature-highlight">hundreds of Porsches</span> across every generation — from air-cooled classics to the latest 992s. Pick the exact model you're researching.</>
    )
  },
  {
    image: finetuneImg,
    title: "Fine-tune the details that matter",
    description: (
      <>Carefully select from the <span className="how-it-works__feature-highlight">options that matter, colors, and specs</span> that make each car special. Dial in transmission, mileage, paint, interior, and more for an exact match.</>
    )
  },
  {
    image: visualizeImg,
    title: "Visualize your market",
    description: (
      <>See <span className="how-it-works__feature-highlight">your market at a glance</span> — every comparable auction plotted clearly so you instantly understand where your Porsche fits.</>
    )
  },
  {
    image: estimateImg,
    title: "Price Guide with real comps",
    description: (
      <>An accurate Price Guide based on real comparable auction results. Filter by model, mileage, color, and more. <span className="how-it-works__feature-highlight">Based on real results</span> — not guesswork.</>
    )
  },
  {
    image: analysisImg,
    title: "Analyze market trends",
    description: (
      <>See the direction of the market compared to previous time periods. Make <span className="how-it-works__feature-highlight">smarter, more confident</span> buying and selling decisions — before the market moves.</>
    )
  },
  {
    image: saveImg,
    title: "Save your favorites",
    description: (
      <>Bookmark the searches that matter to you. <span className="how-it-works__feature-highlight">Never lose track</span> of a model you're following — across Bring a Trailer, PCARMARKET, and Cars & Bids.</>
    )
  }
];

const HowItWorks = () => (
  <section className="how-it-works" id="how">
    <div className="how-it-works__header">
      <div className="how-it-works__badge">How It Works</div>
      <h2 className="how-it-works__headline-main">
        The clarity the<br />market <em className="how-it-works__highlight">hides</em> from you
      </h2>
      <p className="how-it-works__intro-text">
        After writing about Porsche auctions every day for thousands of subscribers, I knew exactly what data mattered — and what didn't. The result is a clean, powerful tool that does the work for you.
      </p>
    </div>

    <div className="how-it-works__features">
      {features.map((feature, index) => (
        <div className={`how-it-works__feature ${index % 2 === 0 ? 'how-it-works__feature--reverse' : ''}`} key={index}>
          <div className="how-it-works__feature-image">
            <img src={feature.image} alt={feature.title} />
          </div>
          <div className="how-it-works__feature-content">
            <span className="how-it-works__feature-number">{String(index + 1).padStart(2, '0')}</span>
            <h3 className="how-it-works__feature-title">{feature.title}</h3>
            <p className="how-it-works__feature-description">{feature.description}</p>
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default HowItWorks;
